import React, { memo } from "react";
import _ from "lodash";
import { Box } from "@mui/material";

const TableMenu = ({ tabs, show = true, absolute, style = {} }) => {
  const renderTab = ({ label, onClick, children }) => {
    if (onClick || label) {
      return (
        <Box onClick={onClick} sx={{ color: "#FFFFFF", cursor: "pointer" }}>
          {label}
        </Box>
      );
    }
    return <>{children}</>;
  };

  if (!show) return <div />;
  return (
    <div
      style={{
        position: absolute ? "absolute" : "fixed",
        zIndex: 1000,
        bottom: "10px",
        right: "50%",
        transform: "translate(50%, -50%)",
        background: "#2E2E2E",
        borderRadius: "4px",
        padding: "16px 24px",
        fontWeight: 500,
        fontSize: 12,
        width: "max-content",
        ...style,
      }}>
      <Box className="row" sx={{ gap: "24px" }}>
        {_.map(tabs, (t) => renderTab(t))}
      </Box>
    </div>
  );
};

export default memo(TableMenu);
